import { Injectable } from '@angular/core';
import { SummaryComponent } from './summary/summary.component';

@Injectable()
export class RouteGeneratorService {
  async initialize(): Promise<void> {
      const routes:any = [];
      const response = await await fetch('/assets/jsondata/reports.json');
      if (response.ok) {
        const data = await response.json();
        for (const menu of data) {
          for (const row of menu.submenu) {
            //console.log(row);
            routes.push({
              path:  row.path.substring('report/'.length),
              //component: SummaryComponent,
              data : {
                title: 'Summary Reports',
                urls: [{ title: 'Home', url: '/main/dashboards/dashboard3' }, { title: 'Reports' }],
                config: row
              }
            });
          }
        }
      } else {
        console.error('Failed to load JSON file');
      }

      //sessionStorage.setItem("Reports", JSON.stringify(routes));
      console.log(routes);
  }
}
